(() => {
  const bind = (root = document) => {
    root.querySelectorAll('[data-wcp-share]').forEach((button) => {
      if (button.dataset.bound === 'true') return;
      button.dataset.bound = 'true';
      button.addEventListener('click', async () => {
        const initial = button.textContent;
        const data = {
          title: button.dataset.shareTitle || document.title,
          text: document.querySelector('.wcp-hero__intro')?.textContent?.trim() || '',
          url: window.location.href
        };
        try {
          if (navigator.share) {
            await navigator.share(data);
          } else {
            await navigator.clipboard.writeText(data.url);
            button.textContent = 'Link copied';
            window.setTimeout(() => { button.textContent = initial; }, 2200);
          }
        } catch (_) {}
      });
    });
  };
  document.addEventListener('DOMContentLoaded', () => bind());
  document.addEventListener('shopify:section:load', (event) => bind(event.target));
})();
